module.exports = __webpack_public_path__ + "645947ae4899a372ab7e7840d20386ff.svg";